<div class="signing-on-pdf">
  <div
    class="arrow-indicator"
    (click)="goToSignatureBox()"
    *ngIf="showIndicator"
  >
    <mat-progress-spinner
      [diameter]="64"
      [value]="(countSignedSignatureBox / countUnlockSignatureBox) * 100"
      [strokeWidth]="4"
    >
    </mat-progress-spinner>
    <div class="indicator-icon">
      <mat-icon>keyboard_backspace</mat-icon>
    </div>
  </div>

  <div class="arrow-indicator__group"></div>

  <div
    #pdfContainerRef
    class="document-pdf"
  >
    <core-pdf-viewer
      [src]="contractPDF"
      (allTextLayersRendered)="allTextLayersRendered($event)"
      (scaleChange)="scaleChange($event)"
    >
    </core-pdf-viewer>
    <portal-signing-signature-box
      [accessToken]="accessToken"
      *ngFor="let signatureBox of signatureBoxes"
      [position]="signatureBox.position"
      [singpassPositions]="singpassPositions"
      [scale]="scale"
      [info]="signatureBox.detail"
      [currentSession]="tokenInfo.uuid"
      [signingTypes]="signingTypes"
      (completed)="signed(signatureBox.key, $event)"
    ></portal-signing-signature-box>
  </div>
</div>
